/**
 * MultiPassword — Password manager
 *
 * Password manager exposing its save and dropdown frames to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 0.99.32.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'cnlhokffphohmfcddnibpohmkdfafdli';
export const multipassword: ExtensionDefinition = {
  id: ID,
  name: "MultiPassword — Password manager",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Password manager exposing its save and dropdown frames to every origin.",
  signals: [
    { id: 'war-save-html', kind: 'web-accessible-resource',
      description: 'Fetch save.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'save.html') },
    { id: 'war-dropdownframe-html', kind: 'web-accessible-resource',
      description: 'Fetch dropdownFrame.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'dropdownFrame.html') },
  ],
};
